import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { serviceStatusData } from "../../../../data";

const { TextArea } = Input;
const AddOrganizationServiceModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);

  const urlService = "api/v1/services/fetch-services";
  const urlOrg = "api/v1/admin/get-dynamicOrganisations";

  const { dataService, dataOrg } = useSelector((state) => ({
    dataService: state.fetch.data[urlService] || [],
    dataOrg: state.fetch.data[urlOrg] || [],
  }));

  const onFinish = async (data) => {
    data.orgServiceId = prodd.orgServiceId ?? null;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/org-services/save-org-service",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.serviceName} for ${prodd?.orgName}` : "Add organization service details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="orgId"
            className=""
            label={<span>Organization</span>}
            rules={[
              {
                required: true,
                message: "Please select organization",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataOrg?.length > 0 &&
                dataOrg?.map((item) => ({
                  value: item?.orgId,
                  label: item?.orgName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="serviceId"
            className=""
            label={<span>Service</span>}
            rules={[
              {
                required: true,
                message: "Please select service",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataService?.length > 0 &&
                dataService?.map((item) => ({
                  value: item?.serviceId,
                  label: item?.serviceName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="orgServiceStatus"
            className=""
            label={<span>Status</span>}
            rules={[
              {
                required: true,
                message: "Please select status",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                serviceStatusData?.length > 0 &&
                serviceStatusData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={saving}
                >
                  {saving ? (
                    <Spin />
                  ) : prodd?.orgServiceId ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddOrganizationServiceModal;
